export const alertConstants = {
    LOADING: 'ALERT_LOADING',
    SUCCESS: 'ALERT_SUCCESS',
    ERROR: 'ALERT_ERROR',
    CLEAR: 'ALERT_CLEAR',
};
